<style lang="less" scoped>
.el-pagination {
  padding-left: 0;
  padding-top: 5px;
}
</style>
<template>
  <div>
    <div class="noData" v-if="!tableData.iTotalRecords"><img src="@/img/icon_emptypage.png"></div>
    <div v-if="tableData.iTotalRecords">
      <el-table :data="tableData.aaData" 
                border 
                @row-click="$emit('row-click',$event)" 
                @current-change="$emit('table-current-change', $event)" 
                @expand-change="$emit('expand-change', $event)" 
                @sort-change="$emit('sort-change', $event)" 
                @selection-change="$emit('selection-change', $event)"
                :row-key="getRowKey" 
                :height="height"
                :expand-row-keys="openColumKes">
        <slot></slot>
      </el-table>
      <el-pagination v-if="(tableData.aaData.length>0) && (tableData.iTotalRecords >=10)"
                    :current-page.sync="tableData.number" 
                    :page-size="tableQuery.size" 
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    :layout="layout" 
                    :total="tableData.iTotalRecords" 
                    @current-change="$emit('current-change', $event)"
                    @size-change="$emit('size-change', $event)"></el-pagination>
      </div>
  </div>
</template>
<script>

export default {
  props: {
    tableQuery: {
      type: Object,
      required: true
    },
    tableData: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: "->, total, sizes, prev, pager, next, jumper"
    },
    openColumKes:{
      type:Array,
      default:function () {
        return []
      }
    },
    height:{
      type: String,
       default:function () {
        return "auto"
      }
    },
    keyField:{//row-key取值字段配置，默认id
      type:String,
      default:'id'
    }
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    rowClick(row){
      this.$emit("rowClick",row)
    },
    getRowKey(row){
      return row[this.keyField];
    }
  },
  computed: {},
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/commonplugin/ajaxPagerTable.vue